import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RoomDetailService } from '../shared/services/room-detail.service';
import { Room } from './../shared/models/rooms.model';
import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-room-detail',
  templateUrl: './room-detail.component.html',
  styleUrls: ['./room-detail.component.scss']
})
export class RoomDetailComponent implements OnInit {

  room: Room;
   @Input() public roomId;
   closeResult: string;

  constructor(
    private route: ActivatedRoute,
    private roomDetailService: RoomDetailService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
      this.room = this.roomDetailService.getRoomDetail(this.roomId);
  }

}
